import { Checkboxes, Fieldset } from 'nhsuk-react-components';
import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';

import { FormQuestions } from '@form';

const Checkbox = forwardRef((props, ref) => {
    const [error, setError] = useState(undefined);
    const [isValid, setIsValid] = useState(undefined);

    useImperativeHandle(ref, () => ({
        validate,
        isValid,
        getValue
    }));

    const validate = () => {
        if (props.question.mandatory) {
            const value = getValue();

            if (!value.length) {
                setError('Please make a selection');
                setIsValid(false);
            } else {
                setError(undefined);
                setIsValid(true);
            }
        } else {
            setError(undefined);
            setIsValid(true);
            props.question.value = removeDuplicates(props.question.value);
            props.question.value = removeLegacyAnswers();
        }
    };

    function removeDuplicates(list) {
        return [...new Set(list)];
    }

    function removeLegacyAnswers() {
        var selected = props.question.value;
        const available = props.question.options;
        if (Array.isArray(selected)) {
            selected = selected.filter(option => available.some(av => av.key === option));
        }
        return selected;
    }

    const getValue = () => {
        const checkboxItems = props.question.value ?? [];
        const uniqueItems = [...new Set(checkboxItems)];
        return uniqueItems;
    };

    const handleChange = async event => {
        // This can go when we upgrade to React 17
        event.persist();

        const oldValue = getValue();
        const newValue = event.target.checked
            ? [...oldValue, event.target.value]
            : oldValue.filter(e => e !== event.target.value);

        await props.onChange({
            questionId: props.question.id,
            linked_questions: props.question.linked_questions || null,
            value: newValue
        });

        validate();
        props.question.value = newValue;

        const option = props.question.options.find(x => x.key === event.target.value);
        if (option && option.questions) {
            props.onConditionalReveal({
                isRevealed: event.target.checked,
                questionIds: option.questions.map(x => x.id)
            });
        }
    };

    useEffect(() => {
        if (props.question.value !== undefined) {
            validate();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.question.value]);

    var value = getValue();
    let hasHidden = false;
    hasHidden = props.question.hidden ?? true;
    if (props.question.value !== undefined) {
        hasHidden = false;
    }
    useEffect(() => {
        if (props.question.clear) {
            props.question.value = undefined;
        }

        props.question.value = removeLegacyAnswers();
        // Used to display child questions when the parent question has been selected
        if (props.questions.some(q => q.id === props.question.parent_id)) {
            const parentQuestion = props.questions.find(q => q.id === props.question.parent_id);
            const parentValues = parentQuestion.ref.current.getValue();
            if (
                parentValues.some(value =>
                    parentQuestion.linked_questions[0].options.includes(value)
                )
            ) {
                props.question.hidden = false;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return !hasHidden || (hasHidden && !props.question.hidden) ? (
        <Fieldset>
            <Fieldset.Legend>{props.question.name}</Fieldset.Legend>
            <Checkboxes hint={props.question.hint_text} name={props.question.name} error={error}>
                {props.question.options.map(option => (
                    <Checkboxes.Box
                        key={option.key}
                        value={option.key}
                        checked={value.includes(option.key)}
                        hint={option.hint_text}
                        onChange={handleChange}
                        required={props.question.mandatory}
                        ref={props.ref}
                        conditional={
                            option.questions
                                ? option.questions.map(question => (
                                      <FormQuestions
                                          question={props.questions.find(x => x.id === question.id)}
                                          questions={props.questions}
                                          key={question.id}
                                          onQuestionChange={props.onChange}
                                          ref={props.questions.find(x => x.id === question.id).ref}
                                      />
                                  ))
                                : undefined
                        }
                    >
                        {option.value}
                    </Checkboxes.Box>
                ))}
            </Checkboxes>
        </Fieldset>
    ) : null;
});

export default Checkbox;
